import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly';
import MobileOffIcon from '@mui/icons-material/MobileOff';
import { Button, useNotify, useRefresh, useUpdate } from 'react-admin';
import { DataProviderResource } from 'src/constants';

interface UpdateUserMfaPreferencesButtonProps {
  id: string;
  enable?: boolean;
}

export const UpdateUserMfaPreferencesButton = ({ id, enable = false }: UpdateUserMfaPreferencesButtonProps) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { isLoading }] = useUpdate();

  const onUpdate = async () => {
    update(
      DataProviderResource.UpdateUserMfaPreferences,
      {
        id,
        data: { isEnabled: enable },
      },
      {
        onSuccess: () => {
          notify('User MFA preferences successfully updated.', { type: 'success' });
        },
        onSettled: () => {
          refresh();
        },
        onError: err => {
          notify(`Failed to update user MFA preferences. Received: ${err}`, {
            type: 'error',
          });
        },
      },
    );
  };

  return (
    <Button label={enable ? 'Enable' : 'Disable'} onClick={onUpdate} disabled={isLoading} style={{ marginTop: '8px' }}>
      {enable ? <MobileFriendlyIcon /> : <MobileOffIcon />}
    </Button>
  );
};
